import { render } from "./Message.vue?vue&type=template&id=1948228f&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=1948228f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1948228f"

export default script